import React from 'react';
import { useParams } from 'react-router';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { useAppSelector } from 'store/hook';

import CommunityView from './CommunityView';

const CompetitorViewWrapper = () => {
  const { viewId } = useParams();
  const { selectedCommunity, selectedParentCommunity } = useAppSelector((state) => state.global);

  const communityId =
    selectedCommunity?.type === COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY
      ? selectedCommunity?.id
      : selectedParentCommunity?.id || -1;

  const competitorId =
    selectedCommunity?.type === COMPANY_COMMUNITY_RELATION_TYPE.COMPETITOR ? selectedCommunity.id : undefined;

  return (
    <CommunityView
      communityId={communityId || -1}
      competitorId={competitorId}
      viewId={parseInt(viewId ?? '')}
      fallbackUrl={`/community/${communityId}`}
    />
  );
};

export default CompetitorViewWrapper;
